// @flow

export const THEMES = {
  bubblegum: {
    key: 'bubblegum',
    label: 'Bubblegum',
    background: 'purple100',
    sortingWeight: 40,
    appearance: {
      theme: 'none',
      variables: {
        fontWeightNormal: '500',
        borderRadius: '2px',
        colorIconTabSelected: 'white',
        spacingGridRow: '15px',
      },
      rules: {
        '.Label': {
          marginBottom: '6px',
        },
        '.Tab, .Input, .Block': {
          boxShadow: '0px 3px 10px rgba(18, 42, 66, 0.08)',
        },
        '.Tab--selected': {
          backgroundColor: '#DF1B41',
          color: 'white',
        },
      },
    },
  },
  none: {
    key: 'none',
    label: 'None',
    background: 'offset',
    sortingWeight: 70,
    appearance: {
      theme: 'none',
    },
  },
  default: {
    key: 'default',
    label: 'Default',
    background: 'offset',
    sortingWeight: 0,
    appearance: {},
  },
  night: {
    key: 'night',
    label: 'Night',
    background: 'gray900',
    sortingWeight: 20,
    appearance: {
      theme: 'night',
    },
  },
  minimal: {
    key: 'minimal',
    label: 'Minimal',
    background: 'white',
    sortingWeight: 30,
    appearance: {
      theme: 'none',
      variables: {
        fontFamily: ' "Gill Sans", sans-serif',
        fontLineHeight: '1.5',
        borderRadius: '10px',
        colorBackground: '#F6F8FA',
      },
      rules: {
        '.Input': {
          border: 'none',
        },
        '.Input:disabled, .Input--invalid:disabled': {
          color: 'lightgray',
        },
        '.Tab': {
          padding: '10px 12px 8px 12px',
          border: 'none',
        },
        '.Tab:hover': {
          border: 'none',
          boxShadow:
            '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
        },
        '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
          border: 'none',
          backgroundColor: '#fff',
          boxShadow:
            '0 0 0 1.5px #262626, 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
          color: '#262626',
        },
        '.Label': {
          fontWeight: '500',
        },
      },
    },
  },
  windows: {
    key: 'windows',
    label: 'Ninety Five',
    background: 'gray200',
    sortingWeight: 40,
    appearance: {
      theme: 'none',
      variables: {
        fontFamily: 'Verdana',
        fontLineHeight: '1.5',
        borderRadius: '0',
        colorBackground: '#dfdfdf',
      },
      rules: {
        '.Input': {
          backgroundColor: '#ffffff',
          boxShadow:
            'inset -1px -1px #ffffff, inset 1px 1px #0a0a0a, inset -2px -2px #dfdfdf, inset 2px 2px #808080',
        },
        '.Input--invalid': {
          color: '#DF1B41',
        },
        '.Tab, .Block': {
          boxShadow:
            'inset -1px -1px #0a0a0a, inset 1px 1px #ffffff, inset -2px -2px #808080, inset 2px 2px #dfdfdf',
        },
        '.Tab:hover': {
          backgroundColor: '#eee',
        },
        '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
          backgroundColor: '#ccc',
        },
      },
    },
  },
  darkBlue: {
    key: 'darkBlue',
    label: 'Dark Blue',
    background: 'blue800',
    sortingWeight: 60,
    appearance: {
      theme: 'none',
      variables: {
        fontFamily: 'Sohne, system-ui, sans-serif',
        fontWeightNormal: '500',
        borderRadius: '8px',
        colorPrimary: '#FFCE48',
        colorText: 'white',
        colorTextSecondary: 'white',
        colorTextPlaceholder: '#727F96',
        colorIconTab: 'white',
        colorIconTabSelected: '#1A1B25',
        colorLogo: 'dark',
      },
      rules: {
        '.Tab, .PickerItem': {
          backgroundColor: '#0A2540',
        },
        '.Tab--selected': {
          backgroundColor: '#FFCE48',
          color: '#1A1B25',
        },
        '.Input, .Block': {
          backgroundColor: 'transparent',
          border: '1.5px solid #FFCE48',
        },
      },
    },
  },
};

// payments-web-bots+payment-intents@stripe.com test account
const PAYWEB_PAYMENT_INTENTS_TEST_PUBLIC_KEY =
  'pk_test_Sds05L2renhqjHCunKB9i5i2';

// jackieosborn+us-bank-account@stripe.com test account, acct_1Kj7bFIIpTIg11XJ
export const PAYWEB_US_BANK_ACCOUNT_TEST_PUBLIC_KEY =
  'pk_test_51Kj7bFIIpTIg11XJtvE76RnimbYycRpo2k8sXpjmKln27syw2XrJInmFJDC3QITWhbZYsQ8xtz5f24qHS1UTd7u600zZqhHYxF';

// pjsevason+klarna-test@stripe.com test DE account
const PAYWEB_KLARNA_TEST_PUBLIC_KEY =
  'pk_test_51JIF4wIPedPoXQNKIe7fGQdOi9GJ4c01DlI5TjKsWCZSmyNah5VZGXGznsyzQQZaJdogsE0qtzG3FAmiPEvC9LqZ00lGPrTU19';

// payments-web-bots+oxxo@stripe.com test account, acct_1G3WczHWyBdE9iZP
const PAYWEB_OXXO_TEST_PUBLIC_KEY =
  'pk_test_SK1cidVzFunKRxyutFt6tfBd00TMUcRsvV';

// payments-web-bots+au-becs-debit@stripe.com test account, acct_1FTMZbABjbJySIWT
const PAYWEB_AU_BECS_DEBIT_TEST_PUBLIC_KEY =
  'pk_test_Bfx5IwoTeK7kUbfS15dcgTrs00beFpWwto';

// BR account for Boleto testing - payments-web-bots+boleto+@stripe.com
const PAYWEB_BOLETO_TEST_PUBLIC_KEY =
  'pk_test_51GsbisHf2CFyfrxeqpCMJKkouDjYAVcP8gfRAEwnyyyoqG6NLCnAal2cDd3PjPs1AtZIjxfFQpbG7QBAytAVEaGX00dUihM48p';

// payments-web-bots+fpx@stripe.com test account
export const PAYWEB_FPX_TEST_PUBLIC_KEY =
  'pk_test_vGCjSmT6Idy5zwfGBKnlq5rd00JT2vbrHb';

// SG account for GrabPay testing - payments-web-bots+grabpay@stripe.com, acct_1FyCAcFA8WHJBsPr
export const PAYWEB_GRABPAY_TEST_PUBLIC_KEY =
  'pk_test_SnHIx1RirG72jSAjVwE3k9dj00blL9YN0H';

// PromptPay test. created via scenarios
// acct_1JZxQGCkS5nzYdNY
// Merchant Country: TH
// Gated into:
// - enable_payment_method_api_promptpay
export const PAYWEB_PROMPTPAY_TEST_PUBLIC_KEY =
  'pk_test_51JZxQGCkS5nzYdNYyP9VIMIRkShz86P7gqCOvqCqJl5IovVqwy6mrDDRke5ylFwv9v4fxcIkbhx8EAbvIlEFVnqe00V6onXDe5';

// JP account for Konbini testing with hosted_voucher_url - payments-web-bots+konbini-vouchers@stripe.com
export const PAYWEB_KONBINI_VOUCHERS_TEST_PUBLIC_KEY =
  'pk_test_51IIpJUAqqVn4m1POinTXOB5Yu1MTUZ9YddpU0f6lQdYK9lzVQpqcGv1BtNKnvsmq1tDNremGW5y5QNZm3Feu0Xp500oU2aTJ3d';

// paymentMethodOrder: Hard coded the preference payment method order for each country
// paymentMethodTypes: Supported payment methods per country
export const LOCATIONS = {
  ae: {
    key: 'ae',
    label: 'United Arab Emirates (AED)',
    paymentMethodOrder: [],
    paymentMethodTypes: ['card'],
    currency: 'aed',
    locale: 'ar-AE',
    publicKey: PAYWEB_PAYMENT_INTENTS_TEST_PUBLIC_KEY,
  },
  au: {
    key: 'au',
    label: 'Australia (AUD)',
    paymentMethodOrder: [
      'card',
      'afterpay_clearpay',
      'au_becs_debit',
      'google_pay',
      'apple_pay',
      'alipay',
    ],
    paymentMethodTypes: [
      'card',
      'afterpay_clearpay',
      'au_becs_debit',
      'alipay',
      'wechat_pay',
    ],
    currency: 'aud',
    locale: 'en',
    publicKey: PAYWEB_AU_BECS_DEBIT_TEST_PUBLIC_KEY,
  },
  br: {
    key: 'br',
    label: 'Brazil (BRL)',
    paymentMethodOrder: ['boleto'],
    paymentMethodTypes: ['boleto', 'card'],
    currency: 'brl',
    locale: 'pt',
    publicKey: PAYWEB_BOLETO_TEST_PUBLIC_KEY,
  },
  cn: {
    key: 'cn',
    label: 'China (CNY)',
    paymentMethodOrder: ['alipay'],
    paymentMethodTypes: ['alipay', 'card', 'wechat_pay'],
    currency: 'cny',
    locale: 'zh',
    publicKey: PAYWEB_PAYMENT_INTENTS_TEST_PUBLIC_KEY,
  },
  de: {
    key: 'de',
    label: 'Germany (EUR)',
    paymentMethodOrder: [
      'card',
      'sepa_debit',
      'klarna',
      'sofort',
      'giropay',
      'google_pay',
      'apple_pay',
      'ideal',
      'bancontact',
      'p24',
    ],
    paymentMethodTypes: [
      'card',
      'sepa_debit',
      'klarna',
      'sofort',
      'giropay',
      'ideal',
      'bancontact',
      'p24',
    ],
    currency: 'eur',
    locale: 'de',
    publicKey: PAYWEB_KLARNA_TEST_PUBLIC_KEY,
  },
  jp: {
    key: 'jp',
    label: 'Japan (JPY)',
    paymentMethodOrder: ['card', 'konbini', 'wechat_pay'],
    paymentMethodTypes: ['card', 'konbini', 'wechat_pay'],
    currency: 'jpy',
    locale: 'ja',
    publicKey: PAYWEB_KONBINI_VOUCHERS_TEST_PUBLIC_KEY,
  },
  mx: {
    key: 'mx',
    label: 'Mexico (MXN)',
    paymentMethodOrder: ['oxxo'],
    paymentMethodTypes: ['oxxo', 'card'],
    currency: 'mxn',
    locale: 'es',
    publicKey: PAYWEB_OXXO_TEST_PUBLIC_KEY,
  },
  my: {
    key: 'my',
    label: 'Malaysia (MYR)',
    paymentMethodOrder: ['fpx', 'card', 'grabpay', 'alipay'],
    paymentMethodTypes: ['fpx', 'card', 'grabpay', 'alipay'],
    currency: 'myr',
    locale: 'my',
    publicKey: PAYWEB_FPX_TEST_PUBLIC_KEY,
  },
  pl: {
    key: 'pl',
    label: 'Poland (PLN)',
    paymentMethodOrder: ['p24'],
    paymentMethodTypes: ['p24', 'card'],
    currency: 'pln',
    locale: 'pl',
    publicKey: PAYWEB_PAYMENT_INTENTS_TEST_PUBLIC_KEY,
  },
  sg: {
    key: 'sg',
    label: 'Singapore (SGD)',
    paymentMethodOrder: ['card', 'grabpay', 'alipay', 'wechat_pay', 'paynow'],
    paymentMethodTypes: ['card', 'grabpay', 'alipay', 'wechat_pay', 'paynow'],
    currency: 'sgd',
    locale: 'en-SG',
    publicKey: PAYWEB_GRABPAY_TEST_PUBLIC_KEY,
  },
  // TODO(adamburmister, 2022-03-01): Release demo when we GA PromptPay
  // th: {
  //   key: 'th',
  //   label: 'Thailand (THB)',
  //   paymentMethodOrder: ['card', 'promptpay'],
  //   paymentMethodTypes: ['card', 'promptpay'],
  //   currency: 'thb',
  //   locale: 'th',
  //   publicKey: PAYWEB_PROMPTPAY_TEST_PUBLIC_KEY,
  // },
  us: {
    key: 'us',
    label: 'United States (USD)',
    paymentMethodOrder: [
      'card',
      'google_pay',
      'apple_pay',
      'us_bank_account',
      'afterpay_clearpay',
    ],
    paymentMethodTypes: [
      'card',
      'us_bank_account',
      'afterpay_clearpay',
      'klarna',
      'wechat_pay',
    ],
    currency: 'usd',
    locale: 'en',
    publicKey: PAYWEB_US_BANK_ACCOUNT_TEST_PUBLIC_KEY,
  },
};

export const SIZES = {
  desktop: {
    key: 'desktop',
    label: 'Desktop',
    value: '510px',
  },
  mobile: {
    key: 'mobile',
    label: 'Mobile',
    value: '320px',
  },
};
